import { configure } from "onedollarstats";

configure();
